import React from 'react';
import { Navigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuth } from 'hooks/useAuth';
import { UserRole } from 'types/user.types';
import { ROUTES } from 'config/routes';

interface RoleGuardProps {
  children: React.ReactNode;
  roles: UserRole[];
  redirectTo?: string;
  showError?: boolean;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ 
  children, 
  roles, 
  redirectTo = ROUTES.DASHBOARD,
  showError = true 
}) => {
  const { userRole, isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  if (!userRole || !roles.includes(userRole)) {
    if (showError) {
      return (
        <Result
          status="403"
          title="403"
          subTitle="К сожалению, у вас нет доступа к этой странице."
          extra={
            <Button type="primary" onClick={() => window.location.href = redirectTo}>
              Вернуться на главную
            </Button>
          }
        />
      );
    }
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;